import router from '@/router'
import { message as $message } from 'ant-design-vue'
import {
  getAddmemberList,
  getRoles,
  getGroups,
  getGroups2,
  saveAddMember,
  getMemberDetail,
  deleteMember,
  editMemberInfo,
  getAddStructureList
} from '@/services/team'
import { serviceInfo } from '@/services/config'
export default {
  namespaced: true,
  state: {
    forbiddenRole: false,
    memberVisible: false, // 成员管理Dialog状态
    memberLoading: false, // 成员管理Dialog 保存Loading状态
    addMemberVisible: false, // 添加成员Dialog状态
    addMemberLoading: false, // 添加成员Dialog 保存Loading状态
    addMemberList: [], // 添加成员待选人员列表
    roleList: [], // 角色列表
    groupList: [], // 小组列表
    groupList2: [], // 小组列表2
    userInfo: {}, // 成员信息
    userLimitInfo: {}, // 添加成员限制信息
    addStructureList: [], // 添加成员列表,
    filterRShow: false
  },
  getters: {
    structureList (state) {
      function loopDeep (arr, pkey) {
        return arr.map(item => {
          item['scopedSlots'] = { title: 'key' }
          item['key'] = item.id
          const key = item['sys_userid'] ? `sys_userid-${item['sys_userid']}` : item['id']
          item['key'] = pkey ? `${pkey}|${key}` : `${key}`
          item['title'] = item
          item['userid'] = item['sys_userid'] ? item.sys_userid : 0
          item['truename'] = item['sys_truename'] ? item['sys_truename'] : item['name']
          item['checkboxtypeLabel'] = 0
          if (item.children && item.children.length) {
            // item['disabled'] = true
            loopDeep(item.children, item['key'])
          }
          // return {
          //   key: item['key'],
          //   title: item['title'],
          //   scopedSlots: { title: 'key' },
          //   children: item.children && item.children.length ? item.children : []
          // }
          return item
        })
      }
      const data = loopDeep(state.addStructureList, null)
      // console.log(data)
      return data
    }
  },
  mutations: {
    setForbiddenRole (state, type) {
      state.forbiddenRole = type
    },

    setUserLimitInfo (state, data) {
      state.userLimitInfo = data
    },
    // 设置添加成员Loading状态
    setAddMemberLoading (state, type) {
      state.addMemberLoading = type
    },
    // 设置添加成员Dialog状态
    setAddMemberVisible (state, type) {
      state.addMemberVisible = type
    },
    // 设置成员管理Dialog状态
    setMemberVisible (state, type) {
      state.memberVisible = type
    },
    // 设置成员管理Loading状态
    setMemberLoading (state, type) {
      state.memberLoading = type
    },
    setAddMemberList (state, data) {
      state.addMemberList = data
    },
    // 设置角色列表数据
    setRoleList (state, data) {
      state.roleList = data
    },
    // 设置组列表数据
    setGroupList (state, data) {
      if (!data.userid) {
        state.groupList = [data]
      } else {
        let array = JSON.parse(JSON.stringify(state.groupList))
        if (array.length === 0) {
          array.push(data)
        } else {
          let count = 0
          array.map(value => {
            if (value.index >= 0) {
              value.index = data.index
            }
            if (value.userid !== data.userid) {
              count += 1
            } else {
              value.groupArray = data.groupArray
            }
          })
          if (count === array.length) {
            array.push(data)
          }
        }
        state.groupList = array
      }
    },
    // 设置组列表数据
    setGroupList2 (state, data) {
      state.groupList2 = data
    },
    // 设置组织结构treeData数据
    setUserInfo (state, data) {
      state.userInfo = data
    },
    setAddStructureList (state, data) {
      state.addStructureList = data
    },
    // 设置角色筛选弹窗状态
    setFilterRShow (state, b) {
      state.filterRShow = b
    }
  },
  actions: {
    // 改变添加成员Dialog状态方法
    changAddMemberVisible ({ commit }, data) {
      commit('setAddMemberVisible', data)
    },
    // 改变添加成员Loading状态方法
    changAddMemberLoading ({ commit }, data) {
      commit('setAddMemberLoading', data)
    },
    // 改变成员管理Dialog状态方法
    changMemberVisible ({ commit, dispatch }, data) {
      commit('setMemberVisible', data.state)
      if (data.key) {
        dispatch('fetchMemberDetail', data.key)
      }
    },
    // 改变成员管理Loading状态方法
    changMemberLoading ({ commit }, data) {
      commit('setMemberLoading', data)
    },
    // 获取添加成员待选人员列表
    async fetchAddmemberList ({ commit }, params) {
      const chain = await getAddmemberList()
        .onNetSuccess(raw => {
          const { error, payload, message } = raw.data
          if (error === 0) {
            commit('setAddMemberVisible', true)
            commit('setAddMemberList', payload.list)
          } else {
            if (error === 104) {
              commit('setUserLimitInfo', payload)
            } else {
              $message.error(message)
            }
          }
        })
        .params({
          ...params
        })
        .config({
          tip: false,
          warn: false
        })
        .fetch()
      return chain
    },
    // 获取添加成员待选人员列表树形列表
    async getAddStructureList ({ commit }, params) {
      const chain = await getAddStructureList()
        .onNetSuccess(raw => {
          const { error, payload, message } = raw.data
          if (error === 0) {
            commit('setAddMemberVisible', true)
            // console.log(payload)
            commit('setAddStructureList', payload)
          } else {
            if (error === 104) {
              commit('setUserLimitInfo', payload)
            } else {
              $message.error(message)
            }
          }
        })
        .params({
          ...params
        })
        .config({
          tip: false,
          warn: false
        })
        .fetch()
      return chain
    },
    // 获取角色列表
    async fetchGetRoles ({ commit }, params) {
      const chain = await getRoles()
        .onSuccess((raw, res) => {
          const { error, payload } = res
          if (error === 0) {
            commit('setRoleList', payload)
          }
        })
        .params({ ...params })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取组列表
    async fetchGetGroups ({ commit }, params) {
      const chain = await getGroups()
        .onSuccess((raw, res) => {
          const { error, payload } = res
          if (error === 0) {
            let json = {}
            json.groupArray = payload
            if (params.index || params.index === 0) {
              json.index = params.index
            }
            if (params.userid) {
              json.userid = params.userid
            }
            commit('setGroupList', json)
          }
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取组列表
    async fetchGetGroups2 ({ commit }, params) {
      const chain = await getGroups2()
        .onSuccess(payload => {
          commit('setGroupList2', payload)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 添加成员---保存
    async fetchSaveAddMember ({ commit, dispatch }, data) {
      const chain = await saveAddMember()
        .onNetSuccess(raw => {
          const { error, payload } = raw.data
          commit('setAddMemberVisible', false)
          commit('setAddMemberLoading', false)
          if (error === 0) {
            commit('setGroupList', payload)
            dispatch('refreshMembersList')
          } else if (error === 104) {
            commit('setUserLimitInfo', payload)
          }
        })
        .params({
          memberinfo: data
        })
        .config({
          tip: false,
          warn: false
        })
        .fetch()
      return chain
    },
    // 删除成员方法
    async fetchDeleteMember ({ commit, dispatch }, userid) {
      const chain = await deleteMember()
        .onSuccess(payload => {
          commit('setMemberLoading', false)
          commit('setMemberVisible', false)
          if (payload.isleader === 1) {
            router.push({ name: 'OrgIndex' })
            return
          }
          dispatch('refreshMembersList')
        })
        .params({
          userid
        })
        .config({
          tip: true,
          selfTip: true
        })
      return chain
    },
    // 编辑成员信息方法
    async fetchEditMemberInfo ({ commit, dispatch }, data) {
      const chain = await editMemberInfo()
        .onSuccess(payload => {
          commit('setMemberLoading', false)
          commit('setMemberVisible', false)
          if (payload.isleader === 1) {
            router.push({ name: 'OrgIndex' })
            return
          }
          dispatch('refreshMembersList')
        })
        .params({
          ...data
        })
        .config({
          tip: true,
          selfTip: true
        })
      return chain
    },
    // 获取用户详细信息
    async fetchMemberDetail ({ commit, dispatch }, userid) {
      const chain = await getMemberDetail()
        .onNetSuccess(raw => {
          if (raw.data.error === 0) {
            commit('setUserInfo', raw.data.payload)
            commit('setForbiddenRole', raw.data.baseinfo.system_role)
            const roleid = raw.data.payload.roleInfo[0].roleid
            const userid = raw.data.payload.userid
            dispatch('fetchGetGroups2', { roleid, userid })
          }
        })
        .params({
          userid
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    refreshMembersList ({ rootState, dispatch }) {
      let selectStr = ''
      if (rootState.team.manage.selectTreenDataKey) {
        selectStr = rootState.team.manage.selectTreenDataKey
      } else {
        selectStr = rootState.team.manage.treeDefaultKey[0]
      }
      if (selectStr.indexOf('|') >= 0) {
        const groupArr = selectStr.split('|')[1]
        const groupInfo = groupArr.split('-')
        dispatch('team/manage/fetchGroupMemberDatas', groupInfo[1], {
          root: true
        })
      } else {
        const tempv = selectStr.split('-')
        const [name, id] = tempv
        if (name === 'projectid') {
          dispatch(
            'team/manage/fetchProjectMemberDatas',
            {},
            {
              root: true
            }
          )
        } else if (name === 'roleid') {
          dispatch('team/manage/fetchTeamMemberDatas', id, {
            root: true
          })
        }
      }
    },
    // 判断是否能邀请
    async serviceInfo ({ commit, dispatch }) {
      const chain = await serviceInfo()
        .onSuccess(payload => {
        })
        .config({
          tip: true,
          selfTip: true
        })
      return chain
    }
  }
}
